import {ResponsiveModal} from '~library/organisms/ResponsiveModal';

import './ExitPremiumPreviewModal.sass';

export const ExitPremiumPreviewModal = ({closeOverlay, onConfirmAction}) => (
  <ResponsiveModal
    isOpen
    onClose={closeOverlay}
    title="Are you sure you want to exit your Premium preview?"
    body="By switching to basic, you'll lose all Premium customizations."
    secondaryAction={onConfirmAction}
    secondaryText="Switch to basic"
    primaryAction={closeOverlay}
    primaryText="Stay in Premium"
  />
);
